<template>
  <div class="parking">
    <van-popup
      v-model="showParkingPicker"
      position="bottom"
      @closed="parkingCarClosed"
    >
      <div class="booking-home-search">
        <div class="booking-home-search-header">
          <div @click="showParkingPicker = false">
            取消
          </div>
          <div class="booking-submit">

          </div>
        </div>
        <div class="booking-division" />
        <div class="parking-list">
          <div
            class="parking-item"
            v-for="(item, index) in parkingList"
            :key="index"
          >
            <div class="parking-item-left">
              <div class="parking-item-name">
                {{ item.parkingNo }}号车位
              </div>
              <div
                class="parking-item-num"
                v-for="(car) in item.carList"
                :key="car.id"
              >
                {{ car.address }}
              </div>
            </div>
            <div
              class="parking-item-right"
              @click="handleParkingForm(item)"
            >
              <van-icon
                name="add-o"
                color="#da0032"
                size="24px"
              />
            </div>
          </div>
        </div>
      </div>
    </van-popup>
    <van-popup
      v-model="showParkingFormPicker"
      position="bottom"
    >
      <div class="booking-home-search">
        <div class="booking-home-search-header">
          <div @click="showParkingFormPicker = false">
            返回
          </div>
          <div class="booking-submit">

          </div>
        </div>
        <div class="booking-division" />
        <div class="parking-form">
          <van-form>
            <van-field
              v-model="form.user_name"
              name="用户名"
              label="用户名"
              placeholder="用户名"
            />
            <van-field
              v-model="form.mobile"
              name="手机号"
              label="手机号"
              placeholder="手机号"
            />
            <van-field
              v-model="form.car_no"
              name="车牌号"
              label="车牌号"
              placeholder="车牌号"
            />
            <van-field
              name="checkboxGroup"
              label="复选框组"
            >
              <template #input>
                <van-checkbox-group v-model="form.time_id">
                  <van-checkbox
                    v-for="item in timeList"
                    :name="item.id"
                    :key="item.id"
                    :disabled="item.disabled"
                    shape="square"
                    checked-color="#da0032"
                  >{{ item.time }}</van-checkbox>
                </van-checkbox-group>
              </template>
            </van-field>
            <div style="margin: 16px;">
              <el-button
                type="danger"
                @click="confirm"
              >保存</el-button>
            </div>
          </van-form>
        </div>
      </div>
    </van-popup>
    <van-popup
      v-model="showParkingDatePicker"
      position="bottom"
      @closed="parkingClosed"
    >
      <div class="booking-home-search">
        <div class="booking-home-search-header">
          <div @click="showParkingDatePicker = false">
            返回
          </div>
          <div class="booking-submit">

          </div>
        </div>
        <div class="booking-division" />
        <div class="parking-date">
          <div
            class="parking-date-item"
            v-for="(item, index) in dateList"
            :key="index"
            @click="changeDate(item)"
          >
            {{ item }}
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import bookingService from "@/apis/booking";
import moment from "moment";

const timeList = [
  {
    time: "07:00~09:00",
    id: "1",
  },
  {
    time: "09:00~11:00",
    id: "2",
  },
  {
    time: "11:00~13:00",
    id: "3",
  },
  {
    time: "13:00~15:00",
    id: "4",
  },
  {
    time: "15:00~17:00",
    id: "5",
  },
];

export default {
  name: "BookingParking",
  data() {
    return {
      showParkingPicker: false,
      showParkingFormPicker: false,
      showParkingDatePicker: false,
      form: {},
      currentDate: "",
      parkingDateMap: {},
      parkingList: [],
      timeList: [],
      dateList: [],
      status: "",
      onlyOneDay: true,
    };
  },

  created() {
    // this.applyParkingCheck();
    this.parkingGetList();
  },
  methods: {
    confirm() {
      const { form, currentDate } = this;
      if (!form.time_id || form.time_id.length === 0) {
        this.$toast.fail("请选择时间段");
        return;
      }
      this.$emit("confirm", {
        ...form,
        expected_date: currentDate,
        time_id: form.time_id.join(","),
        time_list: timeList.filter((item) => form.time_id.includes(item.id)),
      });
      this.status = "conrirm";
      this.showParkingPicker = false;
      this.showParkingFormPicker = false;
      this.showParkingDatePicker = false;
    },
    parkingClosed() {
      const { status } = this;
      if (!status) {
        this.$emit("closed");
      }
    },
    parkingCarClosed() {
      const { onlyOneDay, status } = this;
      if (onlyOneDay && !status) {
        this.$emit("closed");
      }
    },
    parkingGetList() {
      const params = {
        type: 1,
      };
      bookingService.parkingGetList(params).then((res) => {
        const data = res.data;
        const parkingDateMap = {};
        data.forEach((item) => {
          parkingDateMap[moment(item.date).format("YYYY-MM-DD")] = item;
        });
        this.parkingDateMap = parkingDateMap;
        console.log(data);
      });
    },
    showParkingList(date) {
      const { parkingDateMap } = this;
      const currentParkingData = parkingDateMap[date];
      const parkingList = [];
      for (var i = 1; i < 6; i++) {
        const item = {
          parkingNo: i,
        };
        if (currentParkingData) {
          item.carList = currentParkingData.subList.filter(
            (item) => item.parkingNo == i
          );
        } else {
          item.carList = [];
        }
        parkingList.push(item);
      }
      this.parkingList = parkingList;
      this.showParkingPicker = true;
    },
    applyParkingCheck() {
      const params = {
        date: ["2023-09-05"],
      };
      bookingService.applyParkingCheck(params).then((res) => {
        if (res.code === 200) {
          this.$toast.success("申请成功");
        }
      });
    },
    changeDate(item) {
      this.currentDate = item;
      this.showParkingList(item);
      // this.showParkingDatePicker = false;
    },
    handleParking(parkingInfo) {
      const { dateList } = parkingInfo;
      this.dateList = dateList;
      const firstDate = dateList[0];
      this.status = "";
      this.form = {
        ...parkingInfo,
      };
      if (
        dateList.length === 0 ||
        dateList.every((item) => item === firstDate)
      ) {
        this.onlyOneDay = true;
        this.currentDate = firstDate;
        this.showParkingList(firstDate);
        // this.showParkingPicker = true;
      } else {
        this.onlyOneDay = false;
        this.showParkingDatePicker = true;
      }
      // this.applyParkingCheck();
    },
    handleParkingForm(parkingInfo) {
      const { parkingNo } = parkingInfo;
      const { currentDate, parkingDateMap } = this;
      const currentParking = parkingDateMap[currentDate];
      let subList = [];
      if (currentParking) {
        subList = currentParking.subList;
      }
      const timeidList = new Set();
      subList.forEach((item) => {
        if (item.parkingNo == parkingNo) {
          item.timeid.split(",").forEach((item) => {
            timeidList.add(item);
          });
        }
      });
      timeList.forEach((item) => {
        if (timeidList.has(item.id)) {
          item.disabled = true;
        } else {
          item.disabled = false;
        }
      });
      this.form.parking_no = parkingNo;
      this.timeList = timeList;
      this.showParkingFormPicker = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.parking-list {
  padding: 10px 20px;
}
.parking-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e5e5e5;
  padding: 10px 0;
  .parking-item-name {
    font-size: 20px;
  }
  .parking-item-right {
    cursor: pointer;
  }
}
.parking-form {
  .van-checkbox {
    margin-bottom: 10px;
  }
  .el-button {
    width: 100%;
  }
}
.parking-date {
  .parking-date-item {
    padding: 20px 0;
    text-align: center;
    border-bottom: 1px solid #e5e5e5;
  }
}
</style>